import helpers from 'app/app-helpers';
import { fetchDashboard, restoreDefaults, saveDashboard, setEditMode } from 'dashboard/actions/dashboard.actions';
import { checkDirtyForm, setDirtyForm } from 'app/actions/dirty-forms.actions';
import { checkAccess } from 'app/actions/app.actions';
import { isSuperChainSelector } from 'selectors';
import { changePageTitle } from 'auth/actions/session.actions';
import rwDashboardTemplate from './rw-dashboard.html';

const mapStateToThis = ({ dashboard, session, config, dictionary }) => {
  const { isEditMode, isLoading, current } = dashboard;
  const { locale } = session;
  const isSuperChain = isSuperChainSelector({ session });

  const terms = dictionary.terms[locale];
  const applicationName = config.applicationName[locale];

  return {
    isSuperChain,
    isEditMode,
    isLoading,
    session,
    config,
    terms,
    applicationName,
    dashboard: current,
  };
};

const mapDispatchToThis = {
  fetchDashboard,
  setEditMode,
  restoreDefaults,
  saveDashboard,
  checkDirtyForm,
  setDirtyForm,
  checkAccess,
  changePageTitle,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', '$scope', 'gettextCatalog', '$rootScope')
class RwDashboardController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.setPageTitle();
    this.DIRTY_FORM = 'dashboard';
    this.isAlertsWidgetAvailable = this.checkIsAlertsWidgetAvailable();
    if (!!this.retailerType && !!this.subtype) {
      if (this.isDefault) {
        this.restoreDefaults(this.retailerType, this.subtype);
      } else {
        this.fetchDashboard(this.retailerType, this.subtype);
      }
    } else {
      helpers.redirectToFirstPageFromMenu({
        $state: this.$state,
      });
    }
  }

  $onDestroy() {
    this.disableEditMode(true);
    this.unsubscribe();
  }

  openSettings() {
    this.onOpenSettings({
      dashboard: this.dashboard,
    });
  }

  addWidget() {
    this.onAddWidget();
  }

  save(leaveEditMode = true) {
    this.saveDashboard(this.dashboard).then(() => {
      this.setDirtyForm(this.DIRTY_FORM, false);
      if (leaveEditMode) {
        this.disableEditMode(true);
      }
    });
  }

  cancel() {
    if (this.checkDirtyForm(this.DIRTY_FORM)) {
      this.refreshData();
    }
    this.disableEditMode();
  }

  disableEditMode(save = false) {
    this.isEditMode = false;
    this.setEditMode(this.isEditMode, save);
  }

  enableEditMode() {
    this.isEditMode = true;
    this.setEditMode(this.isEditMode);
  }

  onRestoreDefaults() {
    this.restoreDefaults(this.retailerType, this.subtype);
  }

  checkIsAlertsWidgetAvailable() {
    return !this.isSuperChain && this.checkAccess('dashboard.widget.alerts');
  }

  setPageTitle() {
    // Require to support lottery term instant
    if (this.subtype === 'instant') {
      this.changePageTitle(this.gettextCatalog.getString('{{ instant }} Dashboard', { instant: this.terms.INSTANT.plural }));
      this.$rootScope.title = this.gettextCatalog.getString('{{ applicationName }} - {{ instant }} Dashboard', {
        instant: this.terms.INSTANT.plural,
        applicationName: this.applicationName,
      });
    } else {
      this.$state.params.pageTitle = this.gettextCatalog.getString('Summary Dashboard');
      this.$rootScope.title = this.gettextCatalog.getString('{{ applicationName }} - Summary Dashboard', {
        applicationName: this.applicationName,
      });
    }
  }
}

class RwDashboardComponent {
  constructor() {
    this.require = {
      rwDashboardsCtrl: '^rwDashboards',
    };
    this.template = rwDashboardTemplate;
    this.controller = RwDashboardController;
    this.bindings = {
      subtype: '<',
      retailerType: '<',
      widgetsConfig: '<',
      cssClass: '@',
      onAddWidget: '&',
      canCustomizeDashboard: '<',
      isDefault: '<',
      isDisabledShare: '<',
    };
    return this;
  }
}

export default RwDashboardComponent;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-dashboard/rw-dashboard-component.js